<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid user-manager">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>User Manager</h4>
            <b-table
              class="table table-responsive table-bordered mt-3 border"
              responsive="sm"
              :fields="FilterFields"
              :items="FilterItems"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <template v-slot:cell(select_company)="">
                <b-form-select
                  @change="onChangeRecordsPerScreen()"
                  v-model="FilterSelectCompany"
                  :options="FilterSelectCompanyOptions"
                ></b-form-select>
              </template>
              <template v-slot:cell(user_type)="">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio
                    v-model="FilterUserType"
                    :aria-describedby="ariaDescribedby"
                    value="1"
                    @change="onChangeRecordsPerScreen($event, 'userType')"
                    >Users</b-form-radio
                  >
                  <b-form-radio
                    v-model="FilterUserType"
                    :aria-describedby="ariaDescribedby"
                    value="2"
                    @change="onChangeRecordsPerScreen($event, 'userType')"
                    >Admins</b-form-radio
                  >
                  <b-form-radio
                    v-model="FilterUserType"
                    :aria-describedby="ariaDescribedby"
                    value="0"
                    @change="onChangeRecordsPerScreen($event, 'userType')"
                    >All</b-form-radio
                  >
                </b-form-group>
              </template>
              <template v-slot:cell(status)="">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio
                    v-model="FilterStatus"
                    :aria-describedby="ariaDescribedby"
                    value="2"
                    @change="onChangeRecordsPerScreen($event, 'status')"
                    >Active</b-form-radio
                  >
                  <b-form-radio
                    v-model="FilterStatus"
                    :aria-describedby="ariaDescribedby"
                    value="1"
                    @change="onChangeRecordsPerScreen($event, 'status')"
                    >Locked</b-form-radio
                  >
                  <b-form-radio
                    v-model="FilterStatus"
                    :aria-describedby="ariaDescribedby"
                    value="0"
                    @change="onChangeRecordsPerScreen($event, 'status')"
                    >All</b-form-radio
                  >
                </b-form-group>
              </template>
              <template v-slot:cell(records_per_screen)="">
                <b-form-select
                  v-model="FilterRecordsPerScreen"
                  :options="FilterRecordsPerScreenOptions"
                  @change="onChangeRecordsPerScreen()"
                ></b-form-select>
              </template>
              <template v-slot:cell(search)="">
                <form v-on:submit.prevent="onChangeRecordsPerScreen()">
                  <b-input-group>
                    <b-form-input v-model="Search"></b-form-input>
                    <b-input-group-append>
                      <b-button type="submit" variant="primary">
                        <font-awesome-icon icon="search" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </form>
                <br />
                <p>Enter Name, Username or SSN</p>
                <p>Clear text & click Search to remove search.</p>
              </template>
            </b-table>
            <div class="row">
              <div class="col-sm-3">
                <label class="mb-0" style="white-space: nowrap;">Show&nbsp;</label>
                <b-form-select :style="{ width: '50%' }"
                  v-model="FilterRecordsPerScreen"
                  :options="FilterRecordsPerScreenOptions"
                  @change="onChangeRecordsPerScreen()"
                ></b-form-select>
                <label class="mb-0" style="white-space: nowrap;">&nbsp;Entries</label>
              </div>
              <div class="col-sm-7">
                <p>
                  Click on any column header to sort on that column. Click again
                  to reverse order.
                </p>
              </div>
              <div class="col-sm-2">
                <router-link v-if="canEditAndPoints"
                  class="btn btn-primary btn-lg btn-sm-block mr-2"
                  :to="{ name: 'AdminUserManagerAddUser' }"
                  @click.native="scrollToTop"
                >
                  Add User
                </router-link>
              </div>
            </div>
            <div v-if="getPagination.totalRecords > 0">
              <b-table
                class="table table-hover table-responsive table-bordered table-striped my-3 border"
                responsive="sm"
                sort-icon-right
                style="width: 100%"
                hover
                :fields="UserListFields"
                :items="UserListItems"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template #head()="{ label, field: { sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <!-- Custom icons -->
                    <font-awesome-icon icon="sort" />
                  </template>
                </template>
                <template v-slot:cell(points)="data">
                  <span
                    v-if="data.item.points < 0"
                    class="badge badge-danger"
                    >{{
                      data.item.points
                        ? parseInt(data.item.points)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                        : "0.00"
                    }}</span
                  >
                  <span
                    v-else-if="data.item.points >= 0"
                    class="badge badge-success"
                    >{{
                      data.item.points
                        ? parseInt(data.item.points)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                        : "0.00"
                    }}</span
                  >
                </template>
                <template v-slot:cell(locked)="data">
                  <button
                    class="border-0 bg-transparent"
                    @click="
                      $router.push({
                        name: 'LockEditConfirm',
                        params: {
                          userId: data.item.user_id,
                          newLockedState: !data.item.locked,
                          username: data.item.user_name,
                          fullName: data.item.name
                        },
                      })
                    "
                  >
                    <span v-if="data.item.locked === true">
                      <img
                        :src="'https://qa.incentiveweb.com/images/lock.gif'"
                        alt="This user cannt login. Click to unlock this user."
                      />
                    </span>
                    <span v-else>
                      <img
                        :src="'https://qa.incentiveweb.com/images/lockno.gif'"
                        alt="This user can login. Click to unlock this user."
                      />
                    </span>
                  </button>
                </template>
                <template v-slot:cell(tools)="data">
                  <b-button-group size="sm" type="button">

                    <!-- EDIT -->
                    <router-link
                      v-if="canEditAndPoints"
                      :to="{
                        name: 'AdminUserManagerEditUser',
                        params: { userId: data.item.user_id },
                      }"
                      @click.native="scrollToTop"
                      variant="primary"
                      class="btn btn-primary m-1"
                    >
                      Edit
                    </router-link>

                    <!-- POINTS -->
                    <router-link
                      v-if="canEditAndPoints"
                      :to="{
                        name: 'AdminUserManagerPoints',
                        params: { userId: data.item.user_id },
                      }"
                      @click.native="scrollToTop"
                      variant="primary"
                      class="btn btn-primary m-1"
                    >
                      Points
                    </router-link>

                    <!-- REPORTS (always visible) -->
                    <router-link
                      :to="{
                        name: 'AdminUserManagerTransactionReport',
                        params: { userId: data.item.user_id },
                      }"
                      @click.native="scrollToTop"
                      variant="primary"
                      class="btn btn-primary m-1"
                    >
                      Reports
                    </router-link>

                  </b-button-group>
                </template>
              </b-table>
              <div class="d-flex justify-content-between mt-2">
                <div>
                  <span v-if="UserListItems.length === 0"
                    >Showing 0 to 0 of 0 entries</span
                  >
                  <span v-else
                    >Showing
                    {{
                      (PageNo - 1) *
                        getFilterDataForUserManager.recordsPerScreen +
                      1
                    }}
                    to
                    {{ PageNo * getFilterDataForUserManager.recordsPerScreen }}
                    of
                    {{ getPagination.totalRecords }} entries</span
                  >
                </div>
                <div v-if="UserListItems.length > 0">
                  <pagination
                    :data="UserListItems"
                    :totalPages="
                      Math.ceil(
                        getPagination.totalRecords /
                          getFilterDataForUserManager.recordsPerScreen
                      )
                    "
                    :total="getPagination.totalRecords"
                    :perPage="getFilterDataForUserManager.recordsPerScreen"
                    :currentPage="PageNo"
                    @pagechanged="onPageChange"
                  />
                </div>
              </div>
            </div>
            <div v-else class="my-3">
              <label>There are no User records to display.</label>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import Pagination from "@/components/Pagination.vue";
import { mapState } from "vuex";

function decodeJWT(token) {
  if (!token) return null;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

export default {
  name: "AdminUserManager",

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    pagination: Pagination,
  },

  data() {
    return {
      FilterSelectCompany: 0,
      FilterUserType: 0,
      FilterStatus: 2,
      FilterRecordsPerScreen: 5,
      FilterSelectCompanyOptions: [],
      FilterRecordsPerScreenOptions: [
        {
          value: 5,
          text: "5",
        },
        {
          value: 10,
          text: "10",
        },
        {
          value: 50,
          text: "50",
        },
        {
          value: 100,
          text: "100",
        },
        {
          value: 200,
          text: "200",
        },
        {
          value: 500,
          text: "500",
        },
        {
          value: 1000,
          text: "1000",
        },
      ],
      sortBy: "points",
      sortDesc: false,
      FilterFields: [
        {
          key: "select_company",
          thStyle: { width: "30%" },
        },
        {
          key: "user_type",
        },
        {
          key: "status",
        },
        {
          key: "records_per_screen",
          thStyle: { width: "15%" },
        },
        {
          key: "search",
          thStyle: { width: "27%" },
        },
      ],
      FilterItems: [
        {
          select_company: "",
          user_type: "",
          status: "",
          records_per_screen: "",
          search: "",
        },
      ],
      UserListFields: [
        {
          key: "user_id",
          thClass: "d-none",
          tdClass: "d-none",
        },
        {
          key: "user_name",
          sortable: true,
        },
        {
          key: "code",
          sortable: true,
        },
        {
          key: "code2",
          sortable: true,
        },
        {
          key: "points",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "name",
          sortable: true,
        },
        {
          key: "ssn",
          sortable: false,
          label: "SSN",
        },
        {
          key: "locked",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "tools",
          sortable: false,
        },
      ],
      UserListItems: [],
      users: "",
      PageNo: 1,
      Search: "",
      FirstPage: 1,
    };
  },

  computed: {
    getUsers() {
      return this.$store.getters["userManager/getUsersPoint"];
    },
    getPagination() {
      return this.$store.getters["userManager/getPagination"];
    },
    authorizedClients() {
      return this.$store.getters["adminPointPrograms/getAuthorizedClients"];
    },
    getFilterDataForUserManager() {
      return this.$store.getters["userManager/getFilterDataForUserManager"];
    },
    loggedInUserId() {
      const token = localStorage.getItem("jwtToken");
      const payload = decodeJWT(token);
      return payload?.user_id || null;
    },
    canEditAndPoints() {
      // ✅ ONLY this user can edit & add points
      return this.loggedInUserId !== 736036;
    },
  },

  watch: {
    getUsers(getUsers) {
      var datas = getUsers.map(function (data) {
        return {
          user_id: data.id,
          user_name: data.userName,
          code: data.code,
          points: data.points,
          name: data.firstName + " " + data.lastName,
          ssn: data.ssn,
          locked: data.locked,
          code2: data.code2,
        };
      });

      this.UserListItems = datas;
    },

    authorizedClients(authorizedClients) {
      var datas = [];
      authorizedClients.map(function (data) {
        datas.push({
          value: data.clientId,
          text: data.clientName,
        });
      });

      this.FilterSelectCompany =
        !this.getFilterDataForUserManager.companyId && datas.length > 0
          ? datas[0].value
          : this.getFilterDataForUserManager.companyId;
      this.FilterSelectCompanyOptions = datas;

      // filter history
      this.FilterUserType = this.getFilterDataForUserManager.userType;
      this.FilterStatus = this.getFilterDataForUserManager.status;
      this.FilterRecordsPerScreen =
        this.getFilterDataForUserManager.recordsPerScreen;
      this.Search = this.getFilterDataForUserManager.search;

      this.getUserPointsList();
    },

    getPagination(getPagination) {
      this.PageNo = getPagination.pageNo;
    },
  },

  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersUserManager",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },

    onPageChange(page) {
      console.log("page changed", page);
      this.PageNo = page;
      this.getUserPointsList();
    },

    prevPagination: function () {
      this.PageNo--;
      this.onChangeRecordsPerScreen();
    },

    nextPagination: function () {
      this.PageNo++;
      this.onChangeRecordsPerScreen();
    },

    onChangeRecordsPerScreen: function (event, element) {
      this.PageNo = 1;

      if (element === "userType") {
        this.FilterUserType = +event;
      } else if (element === "status") {
        this.FilterStatus = +event;
      }

      if (this.FilterSelectCompany) {
        // setting filters data in user manager state
        this.$store.commit("userManager/SET_FILTER_DATA_FOR_USER_MANAGER", {
          companyId: this.FilterSelectCompany,
          userType: this.FilterUserType,
          status: this.FilterStatus,
          recordsPerScreen: this.FilterRecordsPerScreen,
          search: this.Search,
        });

        this.getUserPointsList();
      } else {
        this.$store.dispatch("userManager/emptyUserPointList");
      }
    },

    getUserPointsList: function () {
      var params = {
        pg_num: this.PageNo,
        pg_size: this.FilterRecordsPerScreen,
        search_term: this.Search,
        sort_field: "ID",
        sort_order: "DESC",
        user_type: this.FilterUserType,
        lock_status_type: this.FilterStatus,
        clientId: this.FilterSelectCompany,
      };
      this.$store.dispatch("userManager/fetchUserPointsList", params);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    console.log('[AdminUserManager] loggedInUsername =', this.loggedInUsername)
    this.setActiveMenuItem();
    this.$store.dispatch("adminPointPrograms/fetchAuthorizedClients");
  },

  destroyed() {
    if (
      this.$route.name === "AdminUserManagerAddUser" ||
      this.$route.name === "AdminUserManagerEditUser" ||
      this.$route.name === "AdminUserManagerPoints" ||
      this.$route.name === "AdminUserManagerTransactionReport"
    ) {
    } else {
      this.$store.commit("userManager/SET_FILTER_DATA_FOR_USER_MANAGER", {
        companyId: 0,
        userType: 0,
        status: 2,
        recordsPerScreen: 5,
        search: "",
      });
    }
  },
};
</script>

<style lang="scss">
.user-manager {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    // padding: 6px 8px;
    border-radius: $border-radius-sm;
  }
  .border table {
    margin: 0px !important;
    padding: 0px;
  }
  .table .table.b-table > thead > tr > [aria-sort="ascending"] {
    background-image: none;
  }
  .table .table.b-table > thead > tr > [aria-sort="descending"] {
    background-image: none;
  }
}
</style>
